<template>
  <svg width="25" height="21" viewBox="0 0 25 21" fill="none" xmlns="http://www.w3.org/2000/svg">
  <line x1="0.75" y1="1.25" x2="24.25" y2="1.25" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <line x1="0.75" y1="9.9458" x2="24.25" y2="9.9458" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <line x1="0.75" y1="19.7285" x2="24.25" y2="19.7285" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 25
    },
    height: {
      type: Number,
      default: 21
    },
    color2: {
      type: String,
      default: 'white'
    },
    color: {
      type: String,
      default: 'var(--color-checked)'
    }
  }
}
</script>

<style>

</style>
